import { t } from "i18next";
import PageSubHeader from "../../../../components/Layouts/PageSubHeader";
import SidebarLayout from "../../../../layouts/SidebarLayout";
import sidebar from "../../utils/sidebar";
import { Col, Nav, NavItem, NavLink, Row, TabContent } from "reactstrap";
import { useState, useEffect } from "react";
import DepartmentsTab from "./Tabs/Departments";
import { get } from "../../../../utils/helpers/api";
import JobPositionsTab from "./Tabs/JobPositions";
import HiringSourcesTab from "./Tabs/HiringSources";
import BenefitTypesTab from "./Tabs/BenefitTypes";

function SettingsPage() {
  const TABS = [
    { id: 'departments', label: 'Departments' },
    { id: 'job-positions', label: 'Job Positions' },
    { id: 'hiring-sources', label: 'Hiring Sources' },
    { id: 'allowances', label: t('hr.settings.allowances.title') },
    { id: 'deductions', label: t('hr.settings.deductions.title') }
  ];
  const [activeTab, setActiveTab] = useState('departments');
  const [loading, setLoading] = useState(false);
  const [departments, setDepartments] = useState(null);
  const [jobPositions, setJobPositions] = useState(null);
  const [hiringSources, setHiringSources] = useState(null);
  const [allowances, setAllowances] = useState(null);
  const [deductions, setDeductions] = useState(null);

  const getSettingsData = async () => {
    setLoading(true);
    const data = await get('/hr/settings');
    if(data?.success) {
      setDepartments(data?.departments);
      setJobPositions(data?.positions);
      setHiringSources(data?.hiring_sources);
      setAllowances(data?.allowances);
      setDeductions(data?.deductions);
    }
    setLoading(false);
  }

  useEffect(() => {
    getSettingsData();
  }, []);

  return(
    <SidebarLayout sidebar={sidebar}>
      <div className="page-with-subheader">
        <PageSubHeader title={ t('settings.title') } />

        <div className="subheader-page-content scrollable">
          <Row className="align-items-start">
            <Col lg="2">
              <Nav pills vertical className="flex-column pref-nav">
                {TABS.map(tab => (
                  <NavItem key={tab.id}>
                    <NavLink
                      active={activeTab === tab.id}
                      onClick={() => setActiveTab(tab.id)}
                      className="cursor-pointer"
                    >
                      {tab.label}
                    </NavLink>
                  </NavItem>
                ))}
              </Nav>
            </Col>

            <Col lg="10">
              <TabContent activeTab={activeTab} className="pref-tab-content">
                <DepartmentsTab
                  departments={departments}
                  refreshSettings={getSettingsData}
                />

                <JobPositionsTab
                  jobPositions={jobPositions}
                  refreshSettings={getSettingsData}
                />

                <HiringSourcesTab
                  hiringSources={hiringSources}
                  refreshSettings={getSettingsData}
                />

                <BenefitTypesTab
                  tabId="allowances"
                  type="allowance"
                  benefitTypes={allowances}
                  refreshSettings={getSettingsData}
                />

                <BenefitTypesTab
                  tabId="deductions"
                  type="deduction"
                  benefitTypes={deductions}
                  refreshSettings={getSettingsData}
                />
              </TabContent>
            </Col>
          </Row>
        </div>
      </div>
    </SidebarLayout>
  );
}

export default SettingsPage;